/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlockchainResponseAdminDto } from '../../models/blockchain-response-admin-dto';

export interface AdminBlockchainsControllerListBlockchainsV1$Params {

/**
 * Optional case-insensitive search applied to label and description
 */
  search?: string;
}

export function adminBlockchainsControllerListBlockchainsV1(http: HttpClient, rootUrl: string, params?: AdminBlockchainsControllerListBlockchainsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BlockchainResponseAdminDto>>> {
  const rb = new RequestBuilder(rootUrl, adminBlockchainsControllerListBlockchainsV1.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BlockchainResponseAdminDto>>;
    })
  );
}

adminBlockchainsControllerListBlockchainsV1.PATH = '/v1/admin/blockchains';
